import { Injectable } from '@angular/core';
import { Parameter } from 'projects/common/src/app/classes';
import { NotificationHandlerService } from 'projects/common/src/app/services';
import { take, map, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ISession } from 'projects/common/src/app/interfaces/authentication';
import { IUser, ICompany } from 'projects/common/src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class UserDataService extends Parameter<IUser> {

  constructor(
    protected notificationService: NotificationHandlerService,
  ) {
    super();
    this.name = 'user-data';
  }

  public init(): Promise<IUser> {
    this.alreadyStarted = true;
    return new Promise((resolve) => {
      this.sourceSubject.pipe(take(1)).subscribe(arg0 => resolve(arg0));
    });
  }

  public startWhen(source: Observable<ISession>): void {
    this.subscription = source.pipe(
      filter((data) => !!data),
      map((data) => data.user),
    ).subscribe(data => {
      this.alreadyStarted = true;
      this.set(data);
    });
  }

  /**
   * Returns an string with the fullname of current user session
   */
  public fullName(): string {
    if (this.hasValue()) {
      return `${this.get().firstName} ${this.get().lastName}`;
    }
    return null;
  }

  /**
   * Returns the id of current user
   */
  public userId(): number {
    if (this.hasValue()) {
      return this.get().id;
    }
    return null;
  }

  /**
   * Returns company values
   */
  public company(): ICompany {
    if (this.hasValue()) {
      return this.get().company;
    }
    return null;
  }

  /**
   * Returns user company identification
   */
  public companyId(): number {
    if (this.company()) {
      return this.companyId();
    }
    return null;
  }
}
